<template>
    <div class="avatar_cropper">
        <el-row type="flex" justify="center">
            <div class="cropper">
                <vueCropper
                    ref="cropper"
                    :img="option.img"
                    :outputSize="option.size"
                    :outputType="option.outputType"
                    :info="option.info"
                    :full="option.full"
                    :canMove="option.canMove"
                    :canMoveBox="option.canMoveBox"
                    :original="option.original"
                    :autoCrop="option.autoCrop"
                    :autoCropWidth="option.autoCropWidth"
                    :autoCropHeight="option.autoCropHeight"
                    :fixedBox="option.fixedBox"
                    :maxImgSize="option.maxImgSize"
                    :enlarge="option.enlarge"
                    :fixed="option.fixed"
                    :fixedNumber="option.fixedNumber"
                    :mode="option.mode"
                    :height="option.height"
                    :centerBox="option.centerBox"
                    :infoTrue="option.infoTrue"
                    @realTime="realTime"
                ></vueCropper>
            </div>
        </el-row>
        <div class="btn_warp">
            <el-button icon="el-icon-refresh-right" circle size="mini"
                       @click="rotateRight"></el-button>
            <div class="flex flex-justify">
                <el-button size="small" type="text" @click="cancelEditAvatar()">取 消</el-button>
                <el-button size="small" type="text" @click="saveEditAvatar()">确 定</el-button>
            </div>

        </div>
    </div>

</template>
<script>
import { uploadImg, getOSSData } from '@/utils/uploadOss'
import { VueCropper } from 'vue-cropper'

export default {
    name: 'Avatar',
    props: {
        editAvatarDialog: {
            type: Boolean,
            default: false
        },
        Avatarfile: {
            type: String,
            default: ''
        }
    },
    components: { VueCropper },
    data () {
        return {
            avatarURL: '',
            previews: {},
            previewStylediv: {},
            option: {
                img: '', // 裁剪图片的地址
                info: true, // 裁剪框的大小信息
                outputSize: 0.5, // 剪切后的图片质量（0.1-1）
                full: true, // 输出原图比例截图 props名full
                outputType: 'jpeg', // 裁剪生成额图片的格式
                canMove: true,  // 能否拖动图片
                original: true,  // 上传图片是否显示原始宽高
                canMoveBox: true,  // 能否拖动截图框
                autoCrop: true, // 是否默认生成截图框
                autoCropWidth: 160,
                autoCropHeight: 160,
                fixedBox: false,// 截图框固定大小
                fixed: true,
                fixedNumber: [1, 1],
                maxImgSize: 360,
                enlarge: 1,
                infoTrue: true,

                height: true,
                centerBox: true, //截图框是否被限制在图片里面
                mode: '160px 160px'
            },

        }
    },
    created () {

    },
    mounted () {
        // this.avatarURL = this.Avatarfile
        this.option.img = this.Avatarfile

    },
    methods: {
        // 压缩图片
        compress (img) {
            let canvas = document.createElement('canvas'),
                ctx = canvas.getContext('2d'),
                initSize = img.src.length
            let width = 160
            let height = 160
            canvas.width = width
            canvas.height = height
            // 铺底色
            ctx.fillStyle = '#fff'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(img, 0, 0, width, height)
            //进行压缩
            let ndata = canvas.toDataURL('image/jpeg', 0.5)
            // console.log("压缩后的图片大小：" + ndata.length)
            return ndata

        },
        // base64转换为Blob
        dataURItoBlob (base64Data) {
            let byteString
            if (base64Data.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(base64Data.split(',')[1])
            } else {
                byteString = unescape(base64Data.split(',')[1])
            }
            let mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0]
            let ia = new Uint8Array(byteString.length)
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i)
            }
            return new Blob([ia], { type: mimeString })
        },

        // 取消
        cancelEditAvatar () {
            this.$emit('update:editAvatarDialog', false)
        },
        // 保存头像修改
        saveEditAvatar () {
            this.finish()
        },
        // 放大/缩小
        changeScale (num) {
            num = num || 1
            this.$refs.cropper.changeScale(num)
        },
        // 左旋转
        rotateLeft () {
            this.$refs.cropper.rotateLeft()
        },
        // 右旋转
        rotateRight () {
            this.$refs.cropper.rotateRight()
        },

        // 保存上传图片
        finish (type) {
            let that = this
            if (type === 'blob') {
                this.$refs.cropper.getCropBlob((data) => {

                    let that = this
                    let file = new window.File([data], '头像.jpg', { type: 'image/jpeg' })
                    uploadImg(file).then((res) => {

                        that.avatarURL = res.file_path
                        that.$emit('update:editAvatarDialog', false)
                        that.$emit('change', that.avatarURL)

                    }).catch(() => {
                    })
                    // this.avatarURL = window.URL.createObjectURL(data)
                    // console.log(this.avatarURL)
                    // 访问接口保存到数据库写这儿!
                })
            } else {
                this.$refs.cropper.getCropData((data) => {
                    let img = new Image()
                    img.src = data
                    img.onload = function () {
                        let _data = that.compress(img)
                        let blob = that.dataURItoBlob(_data)
                        let file = new window.File([blob], '头像.jpg', { type: 'image/jpeg' })

                        uploadImg(file).then((res) => {
                            that.avatarURL = res.file_path
                            that.$emit('update:editAvatarDialog', false)
                            that.$emit('change', that.avatarURL)
                        }).catch(() => {
                        })
                    }
                    //访问接口保存到数据库写这儿!
                })
            }
        },
        // 实时预览函数
        realTime (data) {
            var previews = data
            var h = 0.5
            var w = 0.2
            this.previewStylediv = {
                width: previews.w + 'px',
                height: previews.h + 'px',
                overflow: 'hidden',
                margin: '0 auto 0px',
                zoom: 160 / previews.h
            }

            this.previews = data

        },
        // 下载图片
        down (type) {
            var aLink = document.createElement('a')
            aLink.download = 'author-img'
            if (type === 'blob') {
                this.$refs.cropper.getCropBlob((data) => {
                    aLink.href = window.URL.createObjectURL(data)
                    aLink.click()
                })
            } else {
                this.$refs.cropper.getCropData((data) => {
                    aLink.href = data
                    aLink.click()
                })
            }
        },
        // 更换头像--上传本地图片
        uploadImg (file) {
            var _this = this
            var reader = new FileReader()
            reader.onload = (e) => {
                let data
                if (typeof e.target.result === 'object') {
                    // 把Array Buffer转化为blob 如果是base64不需要
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                _this.option.img = data
            }
            // 转化为base64
            // reader.readAsDataURL(file.raw)
            // 转化为blob
            reader.readAsArrayBuffer(file.raw)
        },

    },
}
</script>
<style lang="scss" scoped>

.vue-cropper{
    background-image: none;
}
.avatar_cropper{
    width: 100%;
    height: 100vh;
    background: #000;
}
.previewBox {
    text-align: center;
    margin-left: 60px;
}

.preview {
    margin: 0px auto 20px auto;
    border-radius: 50%;
    border: 1px solid #ccc;
    background-color: #ccc;
    overflow: hidden;
}
.cropper {
    width:100%;
    height: calc(100vh - 120px);
}

.btn_warp {
    padding: 20px;
    box-sizing: border-box;
    text-align: center;
    margin-top: 20px;
    width: 100%;
    border-top: 1px solid rgba(255,255,255,.5);
    .el-button.is-circle{
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.12);
        border: 0;
    }
    .el-button--text{
        color: #fff;
    }
}
</style>
